'use strict';

var TNColFisheye = (function () {

  var _initialised = {};

  function init(sectionId) {

    if (_initialised[sectionId]) return;
    _initialised[sectionId] = true;

    var wrap    = document.getElementById('tn-colfisheye-wrap-' + sectionId);
    var track   = document.getElementById('tn-colfisheye-track-' + sectionId);
    var prevBtn = document.getElementById('tn-colfisheye-prev-' + sectionId);
    var nextBtn = document.getElementById('tn-colfisheye-next-' + sectionId);
    var dotsEl  = document.getElementById('tn-colfisheye-dots-' + sectionId);

    if (!wrap || !track) return;

    var origSlides = Array.prototype.slice.call(track.querySelectorAll('.tn-colfisheye-slide'));
    var total      = origSlides.length;
    if (total === 0) return;

    var CLONE_COUNT = 3;
    var activePos   = CLONE_COUNT;
    var realIndex   = 0;
    var slideW      = 0;
    var gap         = 16;

    var mouseDown  = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragDeltaX = 0;
    var dragging   = false;
    var dragLocked = false;
    var baseOffset = 0;
    var jumping    = false;

    function isMobile() {
      return window.innerWidth <= 768;
    }

    // function buildClones() {
    //   for (var i = CLONE_COUNT - 1; i >= 0; i--) {
    //     var c = origSlides[i % total].cloneNode(true);
    //     c.setAttribute('aria-hidden', 'true');
    //     c.classList.add('fe-clone');
    //     track.insertBefore(c, track.firstChild);
    //   }
    //   for (var j = 0; j < CLONE_COUNT; j++) {
    //     var c2 = origSlides[j % total].cloneNode(true);
    //     c2.setAttribute('aria-hidden', 'true');
    //     c2.classList.add('fe-clone');
    //     track.appendChild(c2);
    //   }
    // }

    function buildClones() {
  for (var i = CLONE_COUNT - 1; i >= 0; i--) {
    var srcIdx = (total - CLONE_COUNT + i) % total;   // pull from the END of the list
    var c = origSlides[srcIdx].cloneNode(true);
    c.setAttribute('aria-hidden', 'true');
    c.classList.add('fe-clone');
    track.insertBefore(c, track.firstChild);
  }
  for (var j = 0; j < CLONE_COUNT; j++) {
    var c2 = origSlides[j % total].cloneNode(true);   // unchanged — this one was correct
    c2.setAttribute('aria-hidden', 'true');
    c2.classList.add('fe-clone');
    track.appendChild(c2);
  }
}

    function getAllSlides() {
      return Array.prototype.slice.call(track.querySelectorAll('.tn-colfisheye-slide'));
    }

    function setSlideWidths() {
      var wrapW = wrap.offsetWidth;
      gap = isMobile() ? 12 : 16;
      var all = getAllSlides();

      if (isMobile()) {
        slideW = Math.round(wrapW * 0.40);
      } else {
        slideW = Math.round((wrapW - gap * 4) / 5);
      }

      all.forEach(function (slide) {
        slide.style.width      = slideW + 'px';
        slide.style.flexShrink = '0';
        slide.style.marginRight = gap + 'px';
      });
    }

    function centerOffset(pos) {
      var wrapW = wrap.offsetWidth;
      return (slideW + gap) * pos - (wrapW / 2) + (slideW / 2);
    }

    function applyClasses(pos) {
      var all = getAllSlides();
      all.forEach(function (slide, i) {
        slide.classList.remove('fe-lt2', 'fe-lt1', 'fe-center', 'fe-gt1', 'fe-gt2');
        var diff = i - pos;
        if (diff === -2)      slide.classList.add('fe-lt2');
        else if (diff === -1) slide.classList.add('fe-lt1');
        else if (diff === 0)  slide.classList.add('fe-center');
        else if (diff === 1)  slide.classList.add('fe-gt1');
        else if (diff === 2)  slide.classList.add('fe-gt2');
      });
    }

    function setTrack(px, animate) {
      track.style.transition = animate
        ? 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
        : 'none';
      track.style.transform = 'translateX(' + (-px) + 'px)';
    }

    function goToPos(pos, animate) {
      activePos = pos;
      realIndex = ((pos - CLONE_COUNT) % total + total) % total;
      setTrack(centerOffset(pos), animate !== false);
      applyClasses(pos);
      updateDots();
    }

    function jumpIfNeeded() {
      if (jumping) return;
      if (activePos < CLONE_COUNT) {
        jumping = true;
        goToPos(activePos + total, false);
        jumping = false;
      } else if (activePos >= CLONE_COUNT + total) {
        jumping = true;
        goToPos(activePos - total, false);
        jumping = false;
      }
    }

    function buildDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.className = 'tn-colfisheye-dot' + (i === 0 ? ' tn-colfisheye-dot--active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (idx) {
          btn.addEventListener('click', function () { goToPos(CLONE_COUNT + idx, true); });
        }(i));
        dotsEl.appendChild(btn);
      }
    }

    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.tn-colfisheye-dot').forEach(function (dot, i) {
        dot.classList.toggle('tn-colfisheye-dot--active', i === realIndex);
      });
    }

    track.addEventListener('transitionend', jumpIfNeeded);

    if (prevBtn) prevBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goToPos(activePos - 1, true);
    });

    if (nextBtn) nextBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      goToPos(activePos + 1, true);
    });

    track.addEventListener('click', function (e) {
      if (dragging) return;
      var slide = e.target.closest('.tn-colfisheye-slide');
      if (!slide) return;
      var all = getAllSlides();
      var idx = all.indexOf(slide);
      if (idx === -1 || idx === activePos) return;
      if (idx < activePos) goToPos(activePos - 1, true);
      else                 goToPos(activePos + 1, true);
    });

    wrap.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      mouseDown  = true;
      dragging   = false;
      dragLocked = false;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragDeltaX = 0;
      baseOffset = centerOffset(activePos);
      track.style.transition = 'none';
      wrap.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', function (e) {
      if (!mouseDown || dragLocked) return;
      var dx = dragStartX - e.clientX;
      var dy = dragStartY - e.clientY;
      if (!dragging) {
        if (Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        if (Math.abs(dy) > Math.abs(dx)) { dragLocked = true; return; }
        dragging = true;
      }
      dragDeltaX = dx;
      setTrack(baseOffset + dragDeltaX, false);
    });

    document.addEventListener('mouseup', function () {
      if (!mouseDown) return;
      mouseDown = false;
      wrap.style.cursor = 'grab';
      if (!dragging) { dragging = false; dragLocked = false; return; }
      dragging = false; dragLocked = false;
      var threshold = Math.max(40, slideW * 0.25);
      if      (dragDeltaX >  threshold) goToPos(activePos + 1, true);
      else if (dragDeltaX < -threshold) goToPos(activePos - 1, true);
      else                              goToPos(activePos, true);
    });

    wrap.addEventListener('touchstart', function (e) {
      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      dragDeltaX = 0;
      dragging   = false;
      dragLocked = false;
      baseOffset = centerOffset(activePos);
    }, { passive: true });

    wrap.addEventListener('touchmove', function (e) {
      if (dragLocked) return;
      var dx = dragStartX - e.touches[0].clientX;
      var dy = dragStartY - e.touches[0].clientY;
      if (!dragging) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { dragLocked = true; return; }
        dragging = true;
      }
      e.preventDefault();
      dragDeltaX = dx;
      setTrack(baseOffset + dragDeltaX, false);
    }, { passive: false });

    wrap.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false; dragLocked = false;
      var threshold = Math.max(40, slideW * 0.25);
      if      (dragDeltaX >  threshold) goToPos(activePos + 1, true);
      else if (dragDeltaX < -threshold) goToPos(activePos - 1, true);
      else                              goToPos(activePos, true);
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        setSlideWidths();
        goToPos(activePos, false);
      }, 150);
    });

    buildClones();
    track.style.visibility = 'hidden';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        setSlideWidths();
        buildDots();
        goToPos(CLONE_COUNT, false);
        track.style.visibility = '';
      });
    });
  }

  return { init: init };

})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[id^="tn-colfisheye-wrap-"]').forEach(function (el) {
    var sectionId = el.id.replace('tn-colfisheye-wrap-', '');
    TNColFisheye.init(sectionId);
  });
});
